import { useEffect, useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * @memberOf Playtech.API.events
 * @event GAME_LAUNCH
 * @type {callback}
 * @param {Object[]} details
 * @param {string} details[0].gameCode
 * @param {string} details[0].container
 * @param {string} details[0].gameName
 * @param {string} details[0].launchType Values: 'Real' | 'Demo'
 * @param {string} [details[0].gameFeed]
 * @param {string} [details[0].gameName]
 * @example Playtech.on('GAME_LAUNCH', ({ gameCode, container, gameName, launchType }) => { ... });
 */
export const GAME_LAUNCH = 'GAME_LAUNCH';

export const useOnGameLaunch = (eventTarget) => {
    const trackGameLaunch = useCallback(({ game, mode, options = {} }) => {
        const { gameCode, name } = game;
        const { gameName, container, gameFeed, isReactGame } = options;
        const commonDetails = {
            gameCode,
            container,
            gameName: name,
            launchType: mode ? 'Real' : 'Demo'
        };

        const event = new CustomEvent(GAME_LAUNCH, {
            detail: [{
                ...commonDetails,
                ...isReactGame && {
                    gameFeed,
                    gameName
                }
            }]
        });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('game-launch', trackGameLaunch);

        return () => {
            publicEventsAPIService.off('game-launch', trackGameLaunch);
        };
    }, [trackGameLaunch]);
};
